import { render, staticRenderFns } from "./addNewCustomer.vue?vue&type=template&id=01582a74&scoped=true&"
import script from "./addNewCustomer.vue?vue&type=script&lang=js&"
export * from "./addNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./addNewCustomer.vue?vue&type=style&index=0&id=01582a74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01582a74",
  null
  
)

export default component.exports